(function () {
    'use strict';

    function contactAccountManagersController($scope, $route, $routeParams, $location, sessionDataService, mailRequestDataService, notifyService) {
        var self = this;
        this.entityId = '';
        this.insuranceAgencies = [];

        this.init = function () {
            sessionDataService.loadSession().then(function (sessionData) {
                self.entityId = sessionData.EntityId;
            });
        };

        this.contactAccountManager = function (accountManagerId) {
            mailRequestDataService.contactAccountManager({
                'EntityId': self.entityId,
                'AccountManagerId': accountManagerId
            }).then(function (data) {
                notifyService.notify('Your contact request was successfully sent.');
            });
        }

        this.init();
    }

    contactAccountManagersController.$inject = ['$scope', '$route', '$routeParams', '$location', 'sessionDataService', 'mailRequestDataService', 'notifyService'];

    angular.module('ecap.common').controller('contactAccountManagersController', contactAccountManagersController);
})();